<template>
  <div id="app">
    <nav-bar></nav-bar>
    <div class="content">
      <router-view :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'

export default {
  name: 'app',
  components: {
    NavBar
  }
}
</script>

<style lang="scss">
  *{
    margin: 0;
    padding: 0;
  }
  #app{
    width: 100%;
    height: 100%;
  }
  @font-face{
    font-family: 'FZLTZHJW';
    src: url('./components/common/front/FZLTZHJW.TTF');
    font-weight: normal;
    font-style: normal;
}
@import url(./assets/style/common.scss);
// @import url(./common/front/front.css);
</style>

